import React, { createContext, useReducer, useEffect, ReactNode, JSX } from 'react'
import { initialState, authReducer, AuthState, AuthActionTypes } from './authReducer'
import { authRefresh } from './authAction'

interface AuthContextType {
  authState?: AuthState
  authDispatch?: React.Dispatch<AuthActionTypes>
}

export const AuthContext = createContext<AuthContextType>({ authState: initialState })

export const AuthProvider = (props: { rootUrl: string, children: ReactNode }): JSX.Element => {
  const [authState, authDispatch] = useReducer(
    authReducer,
    initialState
  )

  useEffect(() => {
    void authRefresh(authDispatch, props.rootUrl).then()
  }, [])

  return (
    <AuthContext.Provider value={{ authState, authDispatch }}>
      {authState.authInit ? props.children : null}
    </AuthContext.Provider>
  )
}
